const Navbar = ({ scrolled, navigate, scrollToFeatures }) => {

  return (
    <nav style={{
      position: "fixed", top: 0, left: 0, right: 0, zIndex: 100,
      padding: "14px 5%",
      display: "flex", alignItems: "center", justifyContent: "space-between",
      background: scrolled ? "rgba(10,10,24,0.92)" : "transparent",
      backdropFilter: scrolled ? "blur(16px)" : "none",
      borderBottom: scrolled ? "1px solid rgba(255,255,255,0.06)" : "none",
      transition: "all 0.3s",
    }}>
      {/* Logo */}
      <div style={{ display: "flex", alignItems: "center", gap: 10, cursor: "pointer" }} onClick={() => navigate("/")}>
        <div style={{
          width: 38, height: 38, borderRadius: 10,
          background: "linear-gradient(135deg, #6C3CE1, #A855F7)",
          display: "flex", alignItems: "center", justifyContent: "center",
          fontSize: 20, boxShadow: "0 4px 14px #A855F744"
        }}>🕹️</div>
        <span style={{
          fontFamily: "'Fredoka One', cursive", fontSize: 22,
          background: "linear-gradient(90deg, #A855F7, #6C3CE1, #3EAEFF)",
          WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent"
        }}>NovuliGames</span>
      </div>

      {/* Nav Links */}
      <div style={{ display: "flex", gap: 32, alignItems: "center" }}>
        <span className="nav-link" onClick={() => navigate("/")}>Home</span>
        <span className="nav-link" onClick={() => navigate("/games")}>Games</span>
        <span className="nav-link" onClick={scrollToFeatures}>Features</span>
        <span className="nav-link" onClick={() => navigate("/privacy")}>Privacy</span>
        <button className="btn-primary" style={{ padding: "10px 22px", fontSize: 14 }}
          onClick={() => window.open("https://play.google.com/store", "_blank")}>
          ▶ Play Now
        </button>
      </div>
    </nav>
  );
};

export default Navbar;